import FieldsTranslation from "graphql/fields/FieldsTranslation";

export default `
	guid
	updated_at
	timeslot_day
	timeslot_start
	timeslot_end
	capacity
	kind
	sub_kind
	active
	
	translations {
		${FieldsTranslation}
	}
	
	timeslot_exceptions {
		guid
		group_identifier
		updated_at
		kind
		name
		date_start
		date_end
		reduce_by
		increase_by
		comment
		active
	}
`;
